module.exports = __webpack_public_path__ + "img/ru_success_4.2a53dafa.png";